import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _JSXStyle from "styled-jsx/style";
import React from 'react';
import withDefaults from '../utils/with-defaults';
var defaultProps = {
  className: ''
};

var PageFooter = function PageFooter(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement("footer", _extends({}, props, {
    className: "jsx-1607016501" + " " + (props && props.className != null && props.className || "")
  }), children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1607016501"
  }, "footer.jsx-1607016501{width:100%;position:absolute;bottom:0;}"));
};

export default withDefaults(PageFooter, defaultProps);